import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Login from "@/pages/Login";
import Join from "@/pages/Join";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Unsubscribe from "@/pages/Unsubscribe";
import AuthCallback from "@/pages/AuthCallback";
import Directory from "@/pages/Directory";
import CoupleDetail from "@/pages/CoupleDetail";
import Opportunities from "@/pages/Opportunities";
import CoupleDashboard from "@/pages/dashboard/CoupleDashboard";
import VendorDashboard from "@/pages/dashboard/VendorDashboard";
import PostOpportunity from "@/pages/dashboard/PostOpportunity";
import OpportunityApplicants from "@/pages/dashboard/OpportunityApplicants";
import AdminDashboard from "@/pages/dashboard/AdminDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: handle session_id callback synchronously, BEFORE protected routes run
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/about" element={<About />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/login" element={<Login />} />
      <Route path="/join" element={<Join />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/unsubscribe" element={<Unsubscribe />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      <Route path="/directory" element={
        <ProtectedRoute roles={["vendor", "admin"]}><Directory /></ProtectedRoute>
      } />
      <Route path="/couples/:user_id" element={
        <ProtectedRoute roles={["vendor", "admin"]}><CoupleDetail /></ProtectedRoute>
      } />
      <Route path="/opportunities" element={<Opportunities />} />

      <Route path="/dashboard/lovers" element={
        <ProtectedRoute roles={["couple"]}><CoupleDashboard /></ProtectedRoute>
      } />
      {/* Back-compat: legacy URL still routes through */}
      <Route path="/dashboard/couple" element={
        <ProtectedRoute roles={["couple"]}><CoupleDashboard /></ProtectedRoute>
      } />
      <Route path="/dashboard/vendor" element={
        <ProtectedRoute roles={["vendor"]}><VendorDashboard /></ProtectedRoute>
      } />
      <Route path="/dashboard/vendor/post" element={
        <ProtectedRoute roles={["vendor"]}><PostOpportunity /></ProtectedRoute>
      } />
      <Route path="/dashboard/vendor/opportunity/:opp_id" element={
        <ProtectedRoute roles={["vendor", "admin"]}><OpportunityApplicants /></ProtectedRoute>
      } />
      <Route path="/dashboard/admin" element={
        <ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>
      } />

      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
